export default __webpack_public_path__ + "static/media/imageIcon.43e6383e.png";